import _ from '../../core/utils'

const SLIDER_MORE_CONFIG = {
    sliders: _.selectAll( '.fl__slider--more' )
}

export default SLIDER_MORE_CONFIG